import { TFunction } from 'i18next';

import { ProgramMetadata } from '~/features/program/models/program-metadata';
import { toSchoolSlug } from '~/features/school/utils/to-school-slug';

const keyMap = new Map<string, string>();
keyMap.set('animation-and-game-development', 'common.schoolOfAnimationAndGameDevelopment');
keyMap.set('artificial-intelligence', 'common.schoolOfArtificialIntelligence');
keyMap.set('autonomous-systems', 'common.schoolOfAutonomousSystems');
keyMap.set('business', 'common.schoolOfBusiness');
keyMap.set('career-resources', 'common.schoolOfCareerResources');
keyMap.set('cloud-computing', 'common.schoolOfCloudComputing');
keyMap.set('cybersecurity', 'common.schoolOfCybersecurity');
keyMap.set('data-science', 'common.schoolOfDataScience');
keyMap.set('devops', 'common.schoolOfDevOps');
keyMap.set('executive-leadership', 'common.schoolOfExecutiveLeadership');
keyMap.set('product-management', 'common.schoolOfProductManagement');
keyMap.set('programming', 'common.schoolOfProgramming');

const shortNameKeyMap = new Map<string, string>();
shortNameKeyMap.set('artificial-intelligence', 'common.schoolNames.artificialIntelligence');
shortNameKeyMap.set('autonomous-systems', 'common.schoolNames.autonomousSystems');
shortNameKeyMap.set('business', 'common.schoolNames.business');
shortNameKeyMap.set('career-resources', 'common.schoolNames.careerResources');
shortNameKeyMap.set('cloud-computing', 'common.schoolNames.cloudComputing');
shortNameKeyMap.set('cybersecurity', 'common.schoolNames.cybersecurity');
shortNameKeyMap.set('data-science', 'common.schoolNames.dataScience');
shortNameKeyMap.set('animation-and-game-development', 'common.schoolNames.animationAndGameDevelopment');
shortNameKeyMap.set('executive-leadership', 'common.schoolNames.executiveLeadership');
shortNameKeyMap.set('product-management', 'common.schoolNames.productManagement');
shortNameKeyMap.set('programming', 'common.schoolNames.programming');
shortNameKeyMap.set('devops', 'common.schoolNames.devOps');

export function getSchoolName(schoolSlug: string, t: TFunction): string {
  const i18nKey = keyMap.get(schoolSlug);
  return i18nKey ? t(i18nKey) : schoolSlug;
}

export function getSchoolShortName(schoolSlug: string, t: TFunction, language: string): string {
  const i18nKey = shortNameKeyMap.get(schoolSlug);
  return i18nKey ? t(i18nKey, { lng: language }) : schoolSlug;
}

export function getSchoolSlug(programMetadata: ProgramMetadata): string {
  const primarySchool = programMetadata.rootProgram?.schools?.find((school) => school.isPrimary);
  const schoolName = primarySchool ? primarySchool.name : programMetadata.rootProgram?.schools?.[0]?.name || '';
  return toSchoolSlug(schoolName);
}
